import { createSelector } from "reselect";

const currentChapter = (state) => state.currentChapter;

export const getCurrentChapterComponents = createSelector(
  [currentChapter],
  (currentChapter) => currentChapter?.components
);

const menuList = (state) => state.menuList;

export const getMenuList = createSelector([menuList], (menuList) => menuList);

export const getCurrentMenu = createSelector([menuList], (menuList) =>
  menuList.find((menu) => menu.current)
);

export const getNextMenuValue = createSelector([menuList], (menuList) =>
  menuList.reduce((nextMenu, menu, index, menuList) => {
    if (menu.current && menuList[index + 1]) {
      nextMenu = menuList[index + 1].value;
    }
    return nextMenu;
  }, undefined)
);

const notebook = (state) => state.notebook;

export const getTitle = createSelector(
  [notebook],
  (notebook) => notebook.title
);

export const getDescription = createSelector(
  [notebook],
  (notebook) => notebook.description
);

const drawerCollapsed = (state) => state.drawerCollapsed;

export const getDrawerCollapsed = createSelector(
  [drawerCollapsed],
  (drawerCollapsed) => drawerCollapsed
);
